/* eslint-disable @typescript-eslint/ban-ts-comment */
import env from '@utils/env';
import isPublicRoute from '@utils/isPublicRoute';
import { useEffect, useState } from 'react';

const logoutUrl = `${env.WEB_SERVICE_BASE_URI}/logout`;

const UserLogoutOnCloseTab = () => {
  const [checkForSessionStorage, setCheckForSessionStorage] = useState(false);

  const removeParam = (key: string, url = window.location.href) => {
    const urlObj = new URL(url);
    urlObj.searchParams.delete(key);
    return urlObj.toString();
  };

  const checkLogoutUser = () => {
    const queryParams = new URLSearchParams(window.location.search);

    // Note: do not logout user if the URL has queryParam comeFrom=viewer
    if (queryParams.get('comeFrom') === 'viewer') {
      const newUrl = removeParam('comeFrom');
      window.history.pushState({}, '', newUrl); // Update URL without reload
      return;
    }

    // Note: do not logout user if the current path is a public route
    if (isPublicRoute()) {
      return;
    }

    if (sessionStorage.getItem('stayLoggedIn') === null) {
      navigator.sendBeacon(logoutUrl, '');
      setCheckForSessionStorage(false);
      setTimeout(() => {
        window.location.replace('/login');
        sessionStorage.setItem('stayLoggedIn', 'true');
      }, 0);
    }
  };

  useEffect(() => {
    const handleVisibilitychange = () => {
      if (document.visibilityState === 'visible') {
        if (
          // @ts-ignore
          performance.getEntriesByType('navigation')[0].type === 'back_forward'
        ) {
          sessionStorage.clear();
          setCheckForSessionStorage(true);
        }
      }
    };
    const handleLoad = () => {
      if (
        // @ts-ignore
        performance.getEntriesByType('navigation')[0].type === 'back_forward'
      ) {
        sessionStorage.clear();
        setCheckForSessionStorage(true);
      }
    };

    checkLogoutUser();
    window.addEventListener('visibilitychange', handleVisibilitychange);
    window.addEventListener('load', handleLoad);

    return () => {
      window.removeEventListener('visibilitychange', handleVisibilitychange);
      window.removeEventListener('load', handleLoad);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (checkForSessionStorage) {
      checkLogoutUser();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkForSessionStorage]);

  return null;
};

export default UserLogoutOnCloseTab;
